(function() { window.GUID_1a5f2a7f_1ba0_4cbb_84c1_1b3fd971a410 = { getGuid: function() { return "1a5f2a7f-1ba0-4cbb-84c1-1b3fd971a410"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PlayerFeatureId;
        (function (PlayerFeatureId) {
            PlayerFeatureId[PlayerFeatureId["CSRLeaderboard"] = 1] = "CSRLeaderboard";
            PlayerFeatureId[PlayerFeatureId["OpponentsListing"] = 2] = "OpponentsListing";
            PlayerFeatureId[PlayerFeatureId["MatchesListing"] = 3] = "MatchesListing";
            PlayerFeatureId[PlayerFeatureId["Pins"] = 4] = "Pins";
            PlayerFeatureId[PlayerFeatureId["SearchTool"] = 6] = "SearchTool";
            PlayerFeatureId[PlayerFeatureId["PlayerProfile"] = 7] = "PlayerProfile";
            PlayerFeatureId[PlayerFeatureId["EventStatistics"] = 8] = "EventStatistics";
            PlayerFeatureId[PlayerFeatureId["LeagueFeesPayments"] = 9] = "LeagueFeesPayments";
            PlayerFeatureId[PlayerFeatureId["TournamentRegistration"] = 10] = "TournamentRegistration";
            PlayerFeatureId[PlayerFeatureId["PersonalPushNotifications"] = 12] = "PersonalPushNotifications";
            PlayerFeatureId[PlayerFeatureId["TodosList"] = 13] = "TodosList";
            PlayerFeatureId[PlayerFeatureId["FillingOutScoreSheets"] = 14] = "FillingOutScoreSheets";
            PlayerFeatureId[PlayerFeatureId["NoAds"] = 15] = "NoAds";
            PlayerFeatureId[PlayerFeatureId["FollowPlayersAndTeams"] = 16] = "FollowPlayersAndTeams";
            PlayerFeatureId[PlayerFeatureId["Favorites"] = 17] = "Favorites";
            PlayerFeatureId[PlayerFeatureId["MatchDetails"] = 18] = "MatchDetails";
            PlayerFeatureId[PlayerFeatureId["VideosListing"] = 19] = "VideosListing";
            PlayerFeatureId[PlayerFeatureId["FollowAllPlayersAndTeamsOfAnOperator"] = 20] = "FollowAllPlayersAndTeamsOfAnOperator";
            PlayerFeatureId[PlayerFeatureId["QuickTournaments"] = 21] = "QuickTournaments";
            PlayerFeatureId[PlayerFeatureId["ShowLiveResults"] = 23] = "ShowLiveResults";
            PlayerFeatureId[PlayerFeatureId["Graphics"] = 24] = "Graphics";
            PlayerFeatureId[PlayerFeatureId["PlayerComparison"] = 25] = "PlayerComparison";
            PlayerFeatureId[PlayerFeatureId["ExportSchedulesToCalendar"] = 26] = "ExportSchedulesToCalendar";
            PlayerFeatureId[PlayerFeatureId["LiveStreaming"] = 27] = "LiveStreaming";
            PlayerFeatureId[PlayerFeatureId["MoreFeaturesComingSoon"] = 28] = "MoreFeaturesComingSoon";
            PlayerFeatureId[PlayerFeatureId["QuickAccessToPlayersAndTeams"] = 29] = "QuickAccessToPlayersAndTeams";
            PlayerFeatureId[PlayerFeatureId["GamesListing"] = 30] = "GamesListing";
            PlayerFeatureId[PlayerFeatureId["RanksAndAwardsListing"] = 31] = "RanksAndAwardsListing";
            PlayerFeatureId[PlayerFeatureId["LeagueStanding"] = 32] = "LeagueStanding";
            PlayerFeatureId[PlayerFeatureId["RacingCharts"] = 33] = "RacingCharts";
            PlayerFeatureId[PlayerFeatureId["MyCSRDetails"] = 34] = "MyCSRDetails";
            PlayerFeatureId[PlayerFeatureId["SurfaceView"] = 35] = "SurfaceView";
            PlayerFeatureId[PlayerFeatureId["FrozenCSRWall"] = 36] = "FrozenCSRWall";
            PlayerFeatureId[PlayerFeatureId["Custom"] = -1] = "Custom";
        })(PlayerFeatureId = Enumeration.PlayerFeatureId || (Enumeration.PlayerFeatureId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PlayerFeatureId.pre.js.map
